module.exports = __webpack_public_path__ + "static/logo-56e99ea3a098f4aac983b61379221407.png";